module.exports = __webpack_public_path__ + "static/img/C4D0020.324c5f6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/intru/C4D0020.jpg
// module id = CWAM
// module chunks = 0